// export const SAVE_USER_COMMENTS = 'feature/comments/SAVE_USER_COMMENTS' as string
export const SAVE_ALBUM_COMMENTS = 'feature/comments/SAVE_USER_COMMENTS' as string
export const DELETE_USER_COMMENTS = 'feature/comments/DELETE_USER_COMMENTS' as string
export const UPDATE_USER_COMMENTS = 'feature/comments/UPDATE_USER_COMMENTS' as string
export const REPORT_USER_COMMENTS = 'feature/comments/REPORT_USER_COMMENTS' as string
export const HIDE_USER_COMMENTS = 'feature/comments/HIDE_USER_COMMENTS' as string
export const FETCH_ALBUM_COMMENTS = 'feature/comments/FETCH_ALBUM_COMMENTS' as string